<template>
  <div :class="getScreen ? 'm-page-wrapper' : 'd-page-wrapper'">
    <div v-if="id === null || id === undefined">
      <a-card class="m-wrong">
        <m-anim
          :options="notfound"
          class="anim"
          :height="getScreen ? 200 : 500"
          :width="getScreen ? 200 : 500"
        ></m-anim>
        <h3>Not Found</h3>
        <p>Return to the previous page and make the selection manifest again!</p>
        <a-button type="primary" block>
          <router-link to="/sppd">
            <a-icon type="rollback" />&nbsp; Return
          </router-link>
        </a-button>
      </a-card>
    </div>
    <div v-else>
      <a-row :gutter="8">
        <a-col :xs="{span:24}" :lg="{span:16}">
          <a-card :loading="loading">
            <div slot="title">Manifest</div>
            <!-- <a-popover slot="extra" trigger="click" placement="bottom">
              <span slot="title">
                <a-icon type="printer" />&nbsp;Print
              </span>
              <ul class="m-list-wrapper bordered" slot="content">
                <li>
                  <a-button
                    @click="handlePrintManifest"
                    type="dashed"
                    block
                    class="m-display-block"
                    :loading="printLoad.manifest"
                  >Manifest</a-button>
                </li>
              </ul>
              <a-button size="small">
                <a-icon type="printer" />
              </a-button>
            </a-popover> -->
            <a-popover slot="extra" trigger="click" placement="bottom" v-model="visibleAction">
              <span slot="title">Select Action</span>
              <ul class="m-list-wrapper bordered" slot="content">
                <li v-if="data.last_status=='Revised'">
                  <a-button
                    @click="handleEdit"
                    type="dashed"
                    block
                    class="m-display-block"
                    icon="edit"
                  >Edit</a-button>
                </li>
                <li v-if="isphurchasingOrGA && data.last_status=='Approved'">
                  <a-button
                    @click="handleSetSts"
                    type="dashed"
                    block
                    class="m-display-block"
                    :loading="printLoad.sts"
                    :icon="data.suplier.sts_aktif=='1' ? 'close' : 'check'"
                  >{{ data.suplier.sts_aktif=='1' ? 'Set to Non Active' : 'Set to Active' }}</a-button>
                </li>
                <li>
                  <a-button
                    @click="handlePrintManifest"
                    type="dashed"
                    block
                    class="m-display-block"
                    :loading="printLoad.manifest"
                    icon="printer"
                  >Manifest</a-button>
                </li>
              </ul>
              <a-button icon="more">Action</a-button>
            </a-popover>

            <div class="m-card-body">
              <ul class="m-list-wrapper bordered">
                <div class="m-display-flex space-between">
                  <li>
                    <span class="m-list-title" for>Supplier Name</span>
                    <span class="m-list-desc">{{data.suplier.nama_perusahaan}}</span>
                  </li>
                  <li>
                    <span class="m-list-title" for>STATUS : <Status :status="data.suplier.sts_aktif=='1' ?'Active':'Non Active'" /></span>
                  </li>
                </div>
                <li>
                  <span class="m-list-title" for>Address</span>
                  <span class="m-list-desc">{{data.suplier.alamat}}</span>
                </li>
                <li>
                  <span class="m-list-title" for>No. Account Bank</span>
                  <span class="m-list-desc">{{data.suplier.no_rek}}</span>
                </li>
                <li>
                  <span class="m-list-title" for>Bank</span>
                  <span class="m-list-desc">{{data.suplier.bank}}</span>
                </li>
                <li>
                  <span class="m-list-title" for>Contact Person</span>
                  <span class="m-list-desc">{{data.suplier.contact_person}}</span>
                </li>
                <li>
                  <span class="m-list-title" for>Email</span>
                  <span class="m-list-desc">{{data.suplier.email}}</span>
                </li>
                <li>
                  <span class="m-list-title" for>Type of product</span>
                  <span class="m-list-desc">{{data.suplier.jenis_produk}}</span>
                </li>
                <li>
                  <span class="m-list-title" for>Category</span>
                  <span class="m-list-desc">{{data.suplier.kategori}}</span>
                </li>
                <li>
                  <span class="m-list-title" for>PKP</span>
                  <span class="m-list-desc">{{data.suplier.is_pkp=="1" ? "Yes" : "No"}}</span>
                </li>
                <li>
                  <span class="m-list-title" for>Domestic</span>
                  <span class="m-list-desc">{{data.suplier.is_domestic== "DN" ? "Yes" : "No" }}</span>
                </li>
                <li>
                  <span class="m-list-title" for>No. NPWP</span>
                  <span class="m-list-desc">{{ data.suplier.no_npwp }}</span>
                </li>
              </ul>
            </div>
          </a-card>
          <a-card class="margin-top" :loading="loading">
            <div slot="title">Supplier Assessment</div>
            <div slot="extra">
              <a-tag>{{data.suplier.analisa}}</a-tag>
            </div>
            <div>
              <ul class="m-list-wrapper bordered">
                <li>
                  <div class="m-display-flex space-between">
                    <span class="m-list-title" for>Product Specifications</span>
                    <span class="m-list-desc">{{data.suplier.produk}} Point</span>
                  </div>
                  <span class="m-list-desc">{{data.suplier.spesifikasi_produk}}</span>
                </li>
                <li>
                  <div class="m-display-flex space-between">
                    <span class="m-list-title" for>Certificate QMS</span>
                    <span class="m-list-desc">{{data.suplier.qms}} Point</span>
                  </div>
                  <span class="m-list-desc">{{data.suplier.spesifikasi_qms}}</span>
                </li>
                <li>
                  <div class="m-display-flex space-between">
                    <span class="m-list-title" for>Certificate Usaha</span>
                    <span class="m-list-desc">{{data.suplier.usaha}} Point</span>
                  </div>
                  <span class="m-list-desc">{{data.suplier.spesifikasi_usaha}}</span>
                </li>
                <li>
                  <div class="m-display-flex space-between">
                    <span class="m-list-title" for>Risk Analysis</span>
                    <span class="m-list-desc">{{data.suplier.risiko}} Point</span>
                  </div>
                  <span class="m-list-desc">{{data.suplier.analisa_resiko}}</span>
                </li>
              </ul>
            </div>
            <template slot="actions">
              <div class="m-text-align right">
                <h4 class="m-list-desc margin-remove">Total Ratings</h4>
                <h2 class="m-list-desc margin-remove">{{data.suplier.total_score}} Point</h2>
              </div>
            </template>
          </a-card>
          <a-card class="margin-top" :loading="loading">
            <div slot="title">Last Supplier Evaluation<br/>
              <label>{{ (data.last_evaluation.no_manifest ? data.last_evaluation.no_manifest :'-') +" | "
              + (data.last_evaluation.user_pembuat?data.last_evaluation.user_pembuat:'-') +" | "
              + (data.last_evaluation.tgl_buat?moment(data.last_evaluation.tgl_buat).format('DD-MM-YYYY'):'-') }}</label>
            </div>
            <div slot="extra">
              <a-tag>{{data.last_evaluation.kriteria ? data.last_evaluation.kriteria : '-'}}</a-tag>
            </div>
            <div>
              <ul class="m-list-wrapper bordered">
                <li>
                  <div class="m-display-flex space-between">
                    <span class="m-list-title" for>Price</span>
                    <span class="m-list-desc">{{data.last_evaluation.price_point ? data.last_evaluation.price_point : '-'}} Point</span>
                  </div>
                  <span class="m-list-desc">{{data.last_evaluation.price_desc?data.last_evaluation.price_desc:'-'}}</span>
                </li>
                <li>
                  <div class="m-display-flex space-between">
                    <span class="m-list-title" for>Quality</span>
                    <span class="m-list-desc">{{data.last_evaluation.quality_point?data.last_evaluation.quality_point:'-'}} Point</span>
                  </div>
                  <span class="m-list-desc">{{data.last_evaluation.quality_desc?data.last_evaluation.quality_desc:'-'}}</span>
                </li>
                <li>
                  <div class="m-display-flex space-between">
                    <span class="m-list-title" for>Service</span>
                    <span class="m-list-desc">{{data.last_evaluation.service_point?data.last_evaluation.service_point:'-'}} Point</span>
                  </div>
                  <span class="m-list-desc">{{data.last_evaluation.service_desc?data.last_evaluation.service_desc:'-'}}</span>
                </li>
                <li>
                  <div class="m-display-flex space-between">
                    <span class="m-list-title" for>Risk Analysis</span>
                    <span class="m-list-desc">{{data.last_evaluation.risk_analysis_point?data.last_evaluation.risk_analysis_point:'-'}} Point</span>
                  </div>
                  <span class="m-list-desc">{{data.last_evaluation.risk_analysis_desc?data.last_evaluation.risk_analysis_desc:'-'}}</span>
                </li>
              </ul>
            </div>
            <template slot="actions">
              <div class="m-text-align right">
                <h4 class="m-list-desc margin-remove">Total Ratings</h4>
                <h2 class="m-list-desc margin-remove">{{data.last_evaluation.total_score?data.last_evaluation.total_score:'-'}} Point</h2>
              </div>
            </template>
          </a-card>
          <a-card class="margin-top" :loading="loading" v-if="data.jenis !== 'manifest'">
            <div slot="title">Manifest Actions</div>

            <a-form :form="form">
              <a-form-item label="Note">
                <a-textarea
                  placeholder="Write the note here ... "
                  :rows="4"
                  v-decorator="['catatan']"
                />
              </a-form-item>
              <a-form-item label="Aksi">
                <a-select showSearch v-decorator="['aksi', {rules: [{required: true}]}]">
                  <a-select-option v-for="item in data.aksi" :key="item.aksi">{{item.aksi}}</a-select-option>
                </a-select>
              </a-form-item>
              <a-form-item :wrapper-col="{ span: 24 }">
                <a-button @click="handleAction" block type="primary" html-type="submit">Save</a-button>
              </a-form-item>
            </a-form>
          </a-card>
        </a-col>
        <a-col :xs="{span:24}" :lg="{span:8}">
          <a-collapse class="margin-remove" activeKey="1">
            <a-collapse-panel key="1">
              <div class="m-display-flex space-between align-middle" slot="header">
                <h4 class="margin-remove">Transaction Status</h4>
                <div>
                  <Status :status="data.last_status" />
                  <a-button
                    @click="historyToggle"
                    type="default"
                    size="small"
                    class="margin-right-small"
                  >
                    <a-icon type="undo" />
                  </a-button>
                </div>
              </div>
              <a-timeline class="m-timeline">
                <a-timeline-item color="green">
                  <div class="m-timeline-title">Pembuat - {{data.suplier.nama_pembuat}}</div>
                  <div class="m-timeline-body">
                    <h4 class="margin-remove">{{data.suplier.tanggal}}</h4>
                    <span
                      class="m-text-small"
                      v-if="data.suplier.catatan === null || data.suplier.catatan === '' "
                    >Tidak Ada Catatan</span>
                    <span class="m-text-small" v-else>{{data.suplier.catatan}}</span>
                  </div>
                  <div class="m-timeline-footer">
                    <a-tag color="green">Created</a-tag>
                  </div>
                </a-timeline-item>
                <a-timeline-item
                  color="green"
                  v-for="workflow in data.status_app"
                  :key="workflow.step_no"
                >
                  <div class="m-timeline-title">{{workflow.actor}} - {{workflow.tlc}}</div>
                  <div class="m-timeline-body">
                    <h4
                      class="margin-remove"
                      v-if="workflow.tanggal_aksi !== null"
                    >{{moment(workflow.tanggal_aksi).format('DD-MM-YYYY HH:mm:ss')}}</h4>
                    <span
                      class="m-text-small"
                      v-if="workflow.remark === null || workflow.remark === '' "
                    >Tidak Ada Catatan</span>
                    <span class="m-text-small" v-else>{{workflow.remark}}</span>
                  </div>
                  <div class="m-timeline-footer">
                    <Status :status="workflow.status" />
                  </div>
                </a-timeline-item>
              </a-timeline>
            </a-collapse-panel>
          </a-collapse>

          <a-collapse class="margin-top" activeKey="1">
            <a-collapse-panel key="1">
              <div class="m-display-flex space-between align-middle" slot="header">
                <h4 class="margin-remove">Supporting documents</h4>
              </div>
              <a-list itemLayout="horizontal" :dataSource="data.dokumen_pendukung">
                <Empty
                  v-if="data.dokumen_pendukung ? data.dokumen_pendukung.length<=0 : data.dokumen_pendukung"
                />
                <a-list-item slot="renderItem" slot-scope="item">
                  <a-list-item-meta>
                    <div slot="title" class="m-display-flex space-between align-middle">
                      <h4 class="m-list-dots margin-removes">{{item.nama_document}}</h4>
                      <a-button
                        size="small"
                        type="default"
                        icon="cloud-download"
                        @click="handleDownload(item.url)"
                      ></a-button>
                    </div>
                    <p
                      slot="description"
                      :class="getScreen ? 'm-list-dots' : ''"
                    >{{item.fungsi_document}}</p>
                    <img class="m-image-icon" slot="avatar" src="@/assets/icon/pdf_ico.png" />
                  </a-list-item-meta>
                </a-list-item>
              </a-list>
            </a-collapse-panel>
          </a-collapse>

          <a-collapse class="margin-top" activeKey="1">
            <a-collapse-panel key="1">
              <div class="m-display-flex space-between align-middle" slot="header">
                <h4 class="margin-remove">Related Document</h4>
              </div>
              <a-list itemLayout="horizontal" :dataSource="data.dokumen_terkait">
                <Empty />
                <a-list-item slot="renderItem" slot-scope="item">
                  <a-list-item-meta>
                    <div slot="title" class="m-display-flex space-between align-middle">
                      <h4 v-if="item.tipe!='evaluasi suplier'" class="margin-remove">{{item.tipe.toUpperCase()}} | {{item.tlc_pembuat}}</h4>
                      <a v-else class="margin-remove" @click="handleViewProcess(item)">{{item.tipe.toUpperCase()}} | {{item.tlc_pembuat}}</a>
                      <div v-if="item.tipe!='evaluasi suplier'">
                        <Status :status="item.status" />
                        <a-button @click="handleViewProcess(item)" size="small" type="default" icon="eye"></a-button>
                      </div>
                      <div v-else>
                        <span>{{item.no_manifest}}</span><br/>
                        <Rating :rating="item.value"/>
                      </div>
                    </div>
                    <div slot="description" v-if="item.tipe!='evaluasi suplier'">
                      <span>{{item.no_manifest}}</span>
                      <span class="m-display-block">{{moment(item.tgl_buat).format('DD-MM-YYYY')}}</span>
                      <p c v-if="item.deskripsi !== null">{{item.deskripsi}}</p>
                      <p v-else>Tidak Ada Catatan</p>
                    </div>
                  </a-list-item-meta>
                </a-list-item>
              </a-list>
            </a-collapse-panel>
          </a-collapse>
        </a-col>
      </a-row>
    </div>

    <a-modal v-model="visibleHistory" @ok="historyToggle" :footer="null">
      <span slot="title">
        <a-icon type="reload" />&nbsp;History Status
      </span>

      <ul class="m-list-wrapper bordered">
        <li v-for="history in data.notifikasi" :key="history.id_notifikasi">
          <div v-if="history.aksi === '1' || history.aksi === '3'">
            <div class="m-display-flex space-between">
              <h3 class="margin-remove m-list-title">{{history.as_from}} | {{history.tlc_from}}</h3>
              <Status :status="history.deskripsi" />
            </div>
            <span class="m-list-desc">{{history.tgl_notif}}</span>
          </div>
          <div v-else-if="history.aksi === '2' || history.aksi === '4'">
            <div class="m-display-flex space-between">
              <h3
                class="margin-remove m-list-title"
                v-if="history.aksi === '4' && history.deskripsi === 'Edited'"
              >{{history.as_from}} | {{history.tlc_from}}</h3>
              <h3 class="margin-remove m-list-title" v-else>{{history.as_to}} | {{history.tlc_to}}</h3>
              <Status :status="history.deskripsi" />
            </div>
            <span class="m-list-desc">{{history.tgl_notif}}</span>
          </div>
        </li>
      </ul>
    </a-modal>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import lottie from "vue-lottie";
import notfound from "@/assets/anim/notfound.json";
import Status from "@/components/Status.vue";
import Rating from "@/components/Rating.vue";
import Axios from "axios";
import moment from "moment";
import _ from "lodash";
import HandleRoute from "@/mixins/HandleRoute";
import GlobalMethod from "@/mixins/GlobalMethod.js"

export default {
  name: "PurchasingManifest",
  props: ["id", "user_pembuat"],
  components: { "m-anim": lottie, Status, Rating },
  mixins: [HandleRoute, GlobalMethod],
  computed: {
    ...mapGetters(["getScreen", "getAuth", "getIsSpecialMenu"]),
    isphurchasingOrGA(){
      let data = _.filter(this.getAuth.nama_bidang,(obj) => obj=="Purchasing" || obj.includes("General Affair"));
      return data.length>0 ? true : false;
    }
  },
  beforeCreate() {
    this.form = this.$form.createForm(this);
  },
  data() {
    return {
      loading: true,
      printLoad: {
        manifest: false,
        sts: false,
      },
      notfound: { animationData: notfound, loop: true },
      id_supplier: this.id,
      data: {
        status_app: [],
        suplier: [],
        dokumen_terkait: [],
        dokumen_pendukung: [],
        jenis: "",
        status_app: [],
        last_status: "",
        notifikasi: [],
        aksi: [],
        last_evaluation: []
      },
      visibleHistory: false,
      visibleAction: false
    };
  },
  mounted() {
    this.fetchManifest(this.id);
  },
  watch: {
    id() {
      if (this.id) {
        this.fetchManifest(this.id);
      }
    },
  },
  methods: {
    moment,
    fetchManifest(value) {
      this.loading = true;
      Axios({
        method: "get",
        url: this.$serviceUrl + "suplier",
        params: {
          user_pembuat: this.user_pembuat,
          tlc: this.getAuth.username,
          id_manifest: value,
        },
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password,
        },
        headers: {
          "X-API-KEY": this.getAuth.apikey,
        },
      })
        .then((response) => {
          this.data.status_app = response.data.status_app[0];
          this.data.suplier = response.data.suplier[0];
          this.data.dokumen_terkait = response.data.dokumen_terkait;
          this.data.dokumen_pendukung = response.data.dokumen_pendukung;
          this.data.jenis = response.data.jenis;
          this.data.status_app = response.data.status_app;
          this.data.last_status = response.data.last_status;
          this.data.notifikasi = response.data.notifikasi;
          this.data.aksi = response.data.aksi;
          this.data.last_evaluation = response.data.last_evaluation.length>0 ? response.data.last_evaluation[0] : [];
          this.loading = false;
        })
        .catch((err) => {
          console.log(err);
          if (!err.response) {
            let responses = Object.assign({}, err.response.data);
            console.log(responses);
            this.displayMessageValue("error", responses);
            this.$router.go(-1);
          } else {
            this.displayMessage("denied-manifest");
            this.$router.push({ name: "beranda" });
          }
        });
    },
    historyToggle() {
      this.visibleHistory = !this.visibleHistory;
    },

    handleDownload(item) {
      window.open(this.$serviceUrl + item, "_blank");
    },

    handleAction() {
      this.form.validateFields((err, values) => {
        if (err) {
          this.displayMessage("choose-action");
          return;
        }

        Axios({
          method: "put",
          url: this.$serviceUrl + "suplier/approval ",
          processData: false,
          data: {
            id_supplier: this.id,
            tlc: this.getAuth.username,
            status: values.aksi,
            remark: values.catatan ? values.catatan : "",
          },
          auth: {
            username: this.getAuth.username,
            password: this.getAuth.password,
          },
          headers: {
            "Content-Type": "application/json",
            "X-API-KEY": this.getAuth.apikey,
          },
        })
          .then((response) => {
            this.displayMessage("success");
            this.$router.go();
          })
          .catch((err) => {
            console.log("error : " + err);
          });
      });
    },
    handlePrintManifest() {
      this.printLoad.manifest = true;
      Axios({
        method: "get",
        url: this.$serviceUrl + "suplier/cetakmanifest",
        responseType: "blob",
        params: {
          id_supplier: this.id,
        },
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password,
        },
        headers: {
          "X-API-KEY": this.getAuth.apikey,
        },
      })
        .then((response) => {
          let blob = new Blob([response.data], { type: "application/pdf" }),
            url = window.URL.createObjectURL(blob);
          window.open(url, "_blank");
          this.printLoad.manifest = false;
        })
        .catch((err) => {
          if (err.response.status === 404) {
            this.displayMessage("404");
          }
          this.printLoad.manifest = false;
          this.$router.go(-1);
        });
    },
    handleSetSts() {
      this.visibleAction = false
      const that = this;

      this.$confirm({
        title: "Are you sure to "+(this.data.suplier.sts_aktif=='1'?'Non Active':'Active')+" this data?",
        content: "",
        okText: "Yes",
        cancelText: "No",
        onOk() {
          let data = new FormData();
          data.append("id_supplier", that.id);
          data.append("status", that.data.suplier.sts_aktif==1?0:1);

          that.visibleAction = true
          that.printLoad.sts = true;
          that.asyncAxiosPost(
            "suplier/status",
            "formdata",
            that.getAuth,
            data
          )
            .then(() => {
              that.displayMessage("success-edit");
              that.fetchManifest(that.id);
              that.visibleAction = false;
              that.printLoad.sts = false;
            })
            .catch((err) => {
              that.printLoad.sts = false;
              let response = Object.assign({}, err.response);
              if (response.data.status == false && response.data.message) {
                that.displayMessageValue("error-other", response.data.message);
              } else {
                let responses = Object.assign({}, err.response.data);
                that.displayMessageValue("error", responses);
              }
            });
        },
        onCancel() { },
      });
    },
    handleEdit(){
      this.$router.push({
        name: "editPurchasing",
        params: {
          id: this.id,
        },
      });
    },
    handleViewProcess(item){
      if(item.rest_api=='evaluasi_suplier'){
        this.getAuth.nama_bidang.forEach(element => {
          if(element == 'Financial Control'){
            item['to'] = 'Fin';
          }else if( element == 'Purchasing'){
            item['to'] = 'Purchasing';
          }else if( element == 'General Affair Supervisor'){
            item['to'] = 'GA';
          }
        });
        this.handleView(item)
      }else{
        this.handleView(item)
      }
    }
  },
};
</script>

<style lang="less" scoped>
</style>